import { PageHeader } from '@ant-design/pro-layout';
import { Layout, Typography } from 'antd';
import { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useMatch, useNavigate, useParams, useResolvedPath } from 'react-router-dom';
import { ApplicantDetailsHeaderContainer } from '../../../shared/applicant-details-header/applicant-details-header-container';
import { HorizontalTabs, RouteDefinition } from '../../../shared/horizontal-tabs';
import { SubPageLayout } from '../sub-page-layout';
import { ApplicantProfile } from './applicant-profile';
import { ApplicantProfileRequest } from './applicant-profile-request';

interface ApplicantDetailsPage {
  id: string;
  path: string;
  title: string;
}

interface ApplicantDetailsProps {}

export const ApplicantDetails: FC<ApplicantDetailsProps> = () => {
  const navigate = useNavigate();
  const { applicantId } = useParams();


  const applicantDetailsPath = useResolvedPath('');
  const applicantDetailRouteMatch = useMatch(applicantDetailsPath.pathname);



  useEffect(() => {
    if (applicantDetailRouteMatch) {
      navigate('requests', { replace: true });
    } 
  }, [applicantDetailRouteMatch]);


  const pages: ApplicantDetailsPage[] = [
    {
      id: '1',
      path: 'requests',
      title: 'Requests'
    },
    {
      id: '2',
      path: 'profile',
      title: 'Profile'
    }
  ];

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link  to={page.path} replace={true}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  const routes: RouteDefinition[] = [
    { id: '1', path: 'requests/*', element: <ApplicantProfileRequest /> },
    { id: '2', path: 'profile/*', element: <ApplicantProfile /> }
  ];

  return (
    <>
      <Helmet>
        <title>Applicant</title>
      </Helmet>

      <SubPageLayout
        header={
          <PageHeader title={<Typography.Title style={{ fontSize: '30px', marginTop: '12px' }}>Applicant Details</Typography.Title>} onBack={() => navigate(-1)}></PageHeader>
        }
        isNonWhiteBackground={true}
      >
        <div style={{ marginTop: '40px' }}>
          <ApplicantDetailsHeaderContainer applicantId={applicantId ?? ''} />
        </div>
        <Layout style={{ minWidth: '100vh'}}>
          <HorizontalTabs routes={routes} menuItems={configPageNavigationMenu} />
        </Layout>
      </SubPageLayout>

    </>
  );
};
